/**
 * システム設定サービス
 *
 * バックエンドのCallable Functionsを呼び出してシステム設定を管理する
 */

import { httpsCallable } from "firebase/functions";
import { getFunctionsInstance } from "../lib/firebase";

/** OCRプロンプト設定の型 */
export interface OcrPromptConfig {
  /** メインOCRプロンプト */
  basePrompt: string;
  /** 発注元特定用の軽量プロンプト */
  senderIdentificationPrompt: string;
}

/** getSystemOcrPrompt のレスポンス型 */
interface GetOcrPromptResponse {
  /** 現在の設定値 */
  config: OcrPromptConfig;
  /** デフォルト値（「元に戻す」用） */
  defaults: OcrPromptConfig;
}

/**
 * OCRプロンプト設定を取得
 */
export async function fetchSystemOcrPrompt(): Promise<GetOcrPromptResponse> {
  const functions = getFunctionsInstance();
  const getPrompt = httpsCallable<void, GetOcrPromptResponse>(functions, "getSystemOcrPrompt");
  const result = await getPrompt();
  return result.data;
}

/**
 * OCRプロンプト設定を保存
 */
export async function saveSystemOcrPrompt(config: OcrPromptConfig): Promise<void> {
  const functions = getFunctionsInstance();
  const setPrompt = httpsCallable<OcrPromptConfig, { success: boolean }>(
    functions,
    "setSystemOcrPrompt"
  );
  await setPrompt(config);
}
